import { render, staticRenderFns } from "./SideMenuFront.vue?vue&type=template&id=091fdc58&scoped=true"
import script from "./SideMenuFront.vue?vue&type=script&lang=js"
export * from "./SideMenuFront.vue?vue&type=script&lang=js"
import style0 from "./SideMenuFront.vue?vue&type=style&index=0&id=091fdc58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091fdc58",
  null
  
)

export default component.exports